import { render, staticRenderFns } from "./IrAccessJournal.vue?vue&type=template&id=5ab0fae4&"
import script from "./IrAccessJournal.vue?vue&type=script&lang=js&"
export * from "./IrAccessJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports